export default __webpack_public_path__ + "static/media/WorkStation1.fc590ae4.jpg";